import request from './../utils/request'


export function index(params) {
  	return request({
  	  url: '/workTimes',
  	  method: 'get',
        params
  	})
  }

  export function store(data) {
    return request({
      url: '/workTimes',
      method: 'post',
      data
    })
  }

  export function destroy(id) {
    return request({
      url: `/workTimes/${id}`,
      method: 'delete',
    })
  }

  export function inventory(params) {
    return request({
      url: '/workTimes/inventory',
      method: 'get',
      params
    })
  }
